import { Button, Icon, Tooltip } from '@smartgift/frontend-toolkit';
import React from 'react';

import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';

import * as S from './style';

export const Navigation = ({ leftButton, rightButton, secondaryButton, components = {} }) => {
  const { counter, errors } = useValidationErrorsStore();

  return (
    <S.Navigation>
      {leftButton && (
        <Button
          variant="text"
          color="secondary"
          onClick={leftButton.onClick}
          startIcon={leftButton?.icon || <Icon name="left-chevron" />}
        >
          {leftButton.children}
        </Button>
      )}

      <S.RightButtons>
        {components?.SecondaryContent && <components.SecondaryContent />}
        {secondaryButton && (
          <Button variant="text" onClick={secondaryButton.onClick} uppercase={false}>
            {secondaryButton.children}
          </Button>
        )}
        {rightButton && (
          <Tooltip content={rightButton.disabled && rightButton.content} size="md">
            <Button
              onClick={rightButton.onClick}
              disabled={rightButton.disabled}
              loading={rightButton.loading}
              endIcon={rightButton.icon && <Icon name="next" />}
              key={JSON.stringify({ counter, errors })}
              className={Object.values(errors)?.length ? 'element-vibration' : ''}
              color={rightButton?.color || 'primary'}
              variant={rightButton?.variant || 'contained'}
              uppercase={false}
              size="md"
            >
              {rightButton.children}
            </Button>
          </Tooltip>
        )}
      </S.RightButtons>
    </S.Navigation>
  );
};
